import GoodsSoldGraph from './GoodsSoldGraph';
export default GoodsSoldGraph;
